export const findDuplicateIndices = (arr, param) => {
  const nameMap = new Map()
  const duplicates = []

  arr?.forEach((obj, index) => {
    if (nameMap.has(obj[param])) {
      duplicates.push(index)
      nameMap.get(obj[param]).push(index)
    } else {
      nameMap.set(obj[param], [index])
    }
  });
  return duplicates
}